import React, { Component } from 'react';
// Components
import Header from './components/header/header';
import Banner from './components/banner/banner';
import BannerNav from './components/banner_nav/banner_nav';
import Social from './components/social/social';
import Contact from './components/contact/contact';
import Calculator from './components/calculator/calculator';
import Footer from './components/footer/footer';
//import Footer from './components/calculator/totals/sticky_footer'

import scenarios_json from './data/scenarios.json'
import currencies_json from './data/currencies.json'

// Lazy load images
import 'lazysizes/plugins/respimg/ls.respimg.min.js';
import 'lazysizes/plugins/bgset/ls.bgset.min.js';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks.min.js';
import 'lazysizes';

// React Router
import {
  BrowserRouter as Router,
} from 'react-router-dom'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      key: 1,
      isLoading: true,
      showOverlay: false,
      currentScenario: scenarios_json[0],
      currentCurrency: currencies_json[0],
      combinedCosts: 0
    }
  }
  _onLayout = event => {
    this.setState({
      isLoading: false
    })
    this.isLoading = false
  }
  showOverlay(shouldShow) {
    if (shouldShow) {
      this.setState({
        showOverlay: true
      })
    } else {
      this.setState({
        showOverlay: false
      })
    }
  }
  triggerScenarioChange(scenario) {
    this.setState({
      scenarioChange: scenario,
      currentScenario: scenario
    })
  }
  triggerCurrencyChange(currency) {
    this.setState({
      currentCurrency: currency
    })
  }
  triggerDevicePriceChange(device) {
    this.setState({
      devicePriceChange: device
    })
  }
  handleDevicePricingChange(devicePricing){
    this.setState({
      currentDevicePricing: devicePricing 
    })
  }
  handleCombinedCostsChange(value){
    this.setState({
      combinedCosts: value
    })
  }
  render() {
    return (
      <Router>
      <div className="App">
        <Header/>
        <Banner/>
        <BannerNav/>
        <Calculator 
          triggerCurrencyChange={ (currency) => this.triggerCurrencyChange(currency) }
          currentScenario={ this.state.currentScenario }
          updatePricing={ (devicePricing) => this.handleDevicePricingChange(devicePricing) }
          setCurrentScenario={ (scenario) => this.setState({ currentScenario: scenario }) }
          clearTrigger={ () => this.setState({ scenarioChange: null, devicePriceChange: null }) }
          triggerScenarioChange={ this.state.scenarioChange }
          triggerDevicePriceChange={ this.state.devicePriceChange }
          triggerCombinedCostsUpdate={(value) => this.handleCombinedCostsChange(value)}
        />  
        <Contact />
        <Social />
        <Footer />
      </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js